import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloClient, ApolloProvider } from '@apollo/client';
import { initApolloClient } from './graphql';
import { GoogleAnalyticsProvider } from '@mx/metric/frontend';
import { config } from './config';
import { initAppInsights } from './appInsights';
import { initPostHog } from './core/analytics';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
let client: ApolloClient<any>;

initPostHog();

const bootstrap = async () => {
  client = await initApolloClient();
  initAppInsights();
  root.render(
    <GoogleAnalyticsProvider gaId={config.googleAnalytics.measurementId}>
      <ApolloProvider client={client}>
        <Router>
          <App />
        </Router>
      </ApolloProvider>
    </GoogleAnalyticsProvider>,
  );
  reportWebVitals();
};

bootstrap();
